/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import React, { FunctionComponent, useEffect } from "react";
import { useSelector } from "react-redux";
import Alert from "react-bootstrap/Alert";
import { useTranslation } from "react-i18next";
import { isNetworkErrorMessage } from "@advapacs/common";
import { IRootState } from "../../config/reducers";
import { ErrorAction, ApiErrorItem } from "../../reducers/slices/errorSlice";
import { useAppDispatch } from "../../config/store";

const ApiError: FunctionComponent = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation("common");
  const { errors } = useSelector((state: IRootState) => state.errorSlice);

  useEffect(() => {
    return () => {
      dispatch(ErrorAction.setError([]));
    };
  }, [dispatch]);

  const closeError = () => {
    dispatch(ErrorAction.setError([]));
  };
  const getErrorMessage = (error: ApiErrorItem | string) => {
    if (typeof error === "object" && error !== null) {
      const { code, params, message, field } = error;
      if (field && message) return `${field}:${message}`;
      if (message) return `${message}`;
      if (code) return t(`server_error_code.${error.code}`, params);
    }
    return error;
  };
  const lastError = errors[errors.length - 1];
  const variant =
    typeof lastError === "object" && lastError?.severity === "warning"
      ? "warning"
      : "danger";
  const message = getErrorMessage(lastError);
  // Connection errors are shown by NetworkRequestErrorAlert / NetworkStatusAlert.
  const show =
    errors.length > 0 &&
    !isNetworkErrorMessage(message, t("server_error_code.502"));
  return (
    <>
      {show && (
        <Alert variant={variant} onClose={closeError} dismissible>
          {/* @ts-ignore */}
          <div>{message}</div>
        </Alert>
      )}
    </>
  );
};

export default ApiError;
